/**
 * Declares whether an extension handler publishes a stable resource handle or
 * the object produced by its registered reader route.
 *
 * @readonly
 * @enum {string}
 */
export const ResourceHandlerMode = Object.freeze({
  RESOURCE: "resource",
  OBJECT: "object"
});

export default ResourceHandlerMode;
